import { u as useFragmentVersionsRequest } from "./api.js";
function useFragmentVersions(requester) {
  const versions = /* @__PURE__ */ new Map();
  const { requestCustom } = useFragmentVersionsRequest(requester);
  const resolvers = [];
  return {
    loadVersions,
    getVersions,
    getVersion,
    setVersion,
    setVersions,
    hasVersion,
    setVersionResolver
  };
  function hasVersion(fragmentName) {
    return versions.has(fragmentName);
  }
  async function loadVersions({ projectName }) {
    const response = await requestCustom({ retry: true }, projectName);
    const entries = response.fragments.map(({ name, version }) => [name, version]);
    setVersions(Object.fromEntries(entries));
  }
  function getVersions() {
    return versions;
  }
  function resolveVersion(fragmentName) {
    for (const resolver of resolvers) {
      const version = resolver(fragmentName);
      if (version) {
        return version;
      }
    }
  }
  function getVersion(fragmentName) {
    const version = resolveVersion(fragmentName) ?? versions.get(fragmentName);
    if (!version) {
      throw new Error(
        `No version found for fragment "${fragmentName}". Need to add "${fragmentName}" version to the versions service in federationRoot`
      );
    }
    return version;
  }
  function setVersionResolver(newResolver, pre = false) {
    resolvers[pre ? "unshift" : "push"](newResolver);
  }
  function setVersion(fragmentName, version) {
    versions.set(fragmentName, version);
  }
  function setVersions(newVersions) {
    for (const [fragmentName, version] of Object.entries(newVersions)) {
      versions.set(fragmentName, version);
    }
  }
}
export {
  useFragmentVersions as u
};
//# sourceMappingURL=versions.js.map
